
export default {
  name: 'HappyKidsTutorialVideoCard',

  props: {
    data: {
      type: Object,
      default: () => ({
      }),
    },
    videoLink: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: ''
    },
    imgLink: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      isActive: true,
    }
  },

  methods: {
    openVideo(youtubeEmbedLink) {
      console.log('openVideo()...', youtubeEmbedLink)
      this.$store.commit('modal/setVideoModalLink', youtubeEmbedLink);
      this.$store.commit('modal/setShowVideoModal', true);
    },

  }
}
